import React, { useContext, useState } from "react";
import { Modal, Container, Button } from "semantic-ui-react";
import GLGIcon from "./GLGIcon";
import { AppStoreContext } from "../stores/AppStore";
import { post } from "../lib/http";
import { GLOBAL_MODALS } from "../stores/modals";
import {useTranslation, Trans} from "react-i18next";

const pStyle = { padding: "1rem" };
export default function ModalExpired() {
  const appStore = useContext(AppStoreContext);
  const [t] = useTranslation();
  const [accessGranted, setAccessGranted] = useState(false);
  const [isBusy, setIsBusy] = useState(false);
  const { isDNC, emailAddress } = appStore;

  const requestAccessLink = () => {
    setIsBusy(true);
    post("api/requestAccessLink", {
      emailAddress: appStore.emailAddress,
      locale: appStore.locale,
      linkBack: true // makes it like back to cm-onboarding
    })
      .then(() => {
        setAccessGranted(true);
        setIsBusy(false);
      })
      .catch(() => {
        setIsBusy(false);
        appStore.expired = false;
        appStore.globalModal = GLOBAL_MODALS.FATAL_ERROR;
      });
  };

  const renderOptions = () => {
    if (isDNC || !emailAddress) {
      return (
        <Trans i18nKey="for_assistance">
          <a
            href="https://glginsights.com/council-members/contact/"
            target="_blank"
            rel="noopener noreferrer"
          >
          contact copy, DONT TRANSLATE, JUST NEED COPY HERE FOR I18NEXT
          </a>
        </Trans>    
      )
    }
    if (accessGranted) {
      return <strong>{t("access_granted_notice", {emailAddress: appStore.emailAddress})}</strong>
    }

    return (
      <Button
        onClick={requestAccessLink}
        primary
        disabled={isBusy}
        loading={isBusy}
      >
        {t("request_reg_link")}
      </Button>
    )
  }

  return (
    <Modal
      defaultOpen
      closeOnEscape={false}
      closeOnDimmerClick={false}
      size="tiny"
    >
      <Modal.Content>
        <Container textAlign="center" fluid>
          <GLGIcon name="alert-2" size="huge" />
            <p style={pStyle}>
              {t("reg_session_expired")}
              <br />
              <br />
              {renderOptions()}
            </p>
        </Container>
      </Modal.Content>
    </Modal>
  );
}
